import {portMonitorAPI} from 'features/port/api/portMonitorAPI';
import {getPortMonitorModalMode, PortMonitorModalMode} from 'features/port/lib/portMonitorHelper';
import useOpenState from 'shared/lib/hooks/useOpenState';
import {useMonitorModalState} from 'entities/monitor';

import IPortMonitor, {IPortMonitorListItem} from './PortMonitor/IPortMonitor';
import useCanCreatePortMonitor from './useCanCreatePortMonitor';

interface IUsePortMonitorModalParams {
    open: boolean,
    item?: IPortMonitorListItem,
    handleClose: () => void,
}

export interface IUsePortMonitorModal {
    mode: PortMonitorModalMode,
    isNew: boolean,
    isBatchMode: boolean,
    showToggle: boolean,
    canCreate: boolean,
    isFullItemLoading: boolean,
    fullItem: IPortMonitor | undefined,
    isExceededOpen: boolean,
    openExceeded: () => void,
    closeExceeded: () => void,
    toggleBatchMode: () => void,
    setShowResult: (_value: boolean) => void,
    handleCloseAndReset: () => void,
}

export const usePortMonitorModal = ({open, item, handleClose}: IUsePortMonitorModalParams): IUsePortMonitorModal => {
    const exceeded = useOpenState();
    const canCreate = useCanCreatePortMonitor();

    const isNew = !item;
    const {isBatchMode, showToggle, toggleBatchMode, setShowResult, handleCloseAndReset} = useMonitorModalState(
        isNew,
        handleClose,
    );

    const {data: fullItem, isLoading} = portMonitorAPI.useGetPortMonitorQuery(item?.uuid ?? '', {
        skip: !open || isNew,
    });

    return {
        mode: getPortMonitorModalMode(isBatchMode, isNew),
        isNew,
        isBatchMode,
        showToggle,
        canCreate,
        isFullItemLoading: isLoading,
        fullItem,
        isExceededOpen: exceeded.isOpen,
        openExceeded: exceeded.open,
        closeExceeded: exceeded.close,
        toggleBatchMode,
        setShowResult,
        handleCloseAndReset,
    };
};

export default usePortMonitorModal;
